// export const API_URL = 'http://recrutei-dev-api.us-east-1.elasticbeanstalk.com';
// export const API_URL = 'https://api.recrutei.com.br';
export const API_URL = 'https://dev-ats-api.recrutei.com.br';
export const REACT_APP_VACANCY_STATUS_PUBLISHED = 1;
export const REACT_APP_VACANCY_STATUS_DRAFT = 2;
export const REACT_APP_VACANCY_STATUS_DONE = 3;
export const REACT_APP_VACANCY_STATUS_DISABLED = 4;

export const REACT_APP_QUALIFICATION_HEADHUNTER = 1;
export const REACT_APP_QUALIFICATION_CONSULTORIA = 2;
export const REACT_APP_QUALIFICATION_STARTUP = 3;
export const REACT_APP_QUALIFICATION_EMPRESA_TRADICIONAL = 4;

export const MASS_ACTION_ALTER_STATUS_APPROVED = 1;
export const MASS_ACTION_ALTER_STATUS_REPROVED = 2;
export const MASS_ACTION_ALTER_STATUS_NOT_RATED = 3;
export const MASS_ACTION_ALTER_PIPE_STAGE = 4;
export const MASS_ACTION_SEND_EMAIL = 5;
